export default __webpack_public_path__ + "static/media/2007-AMcover.6ede921d.png";